import React, { useState } from "react";

import { resetPassword } from "services";

import { incompleteMessage, useAppType, useNavigate, useToggleNavs, useTranslation } from "utils";

import { ErrorBoundary, Flex, Form, Input, MainPage, ScreenSplit, Typography, Message as message } from "components";

import { PasswordButtons } from "pages/app/account/components/PasswordButtons";
import { TestimonialScreen } from "pages/app/account/components/TestimonialScreen";

interface ShareData {
  title: string;
  summary: string;
  link: string;
  image: string;
}

interface PasswordFormValues {
  email: string;
}

export const Password = () => {
  const { t } = useTranslation(["signinup", "meta"]);
  const appType = useAppType();
  const navigate = useNavigate();
  useToggleNavs(false, appType.mobile);

  const [loading, setLoading] = useState<boolean>(false);
  const [share] = useState<ShareData>({
    title: t("meta:password.title"),
    summary: t("meta:password.description"),
    link: `${process.env.REACT_APP_FARM_URL}/password`,
    image: `${process.env.REACT_APP_FARM_URL}/images/misc/share.png`,
  });

  const complete = (v: PasswordFormValues): void => {
    const controller = new AbortController();
    setLoading(true);

    resetPassword({
      ...v,
      signal: controller.signal,
    })
      .then((res) => {
        if (res?.success) {
          navigate("/sign-in");
          message({ content: t("changePassword.sent"), icon: "tick" });
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <ScreenSplit sideChildren={<TestimonialScreen farmerType="default" />}>
      <MainPage loading={loading} pageName={"sign-in-up"} share={share} containerClass={appType.mobile ? "small" : ""}>
        <section className="container">
          <Flex vertical gap={32} className="mini-form">
            <Flex vertical gap={8}>
              <Typography variant="h2">{t("changePassword.title")}</Typography>
              <Typography variant="paragraph-m">{t("changePassword.description")}</Typography>
            </Flex>
            <Form name="password" onFinish={(v) => complete(v)} onFinishFailed={() => incompleteMessage(t("errors.mandatoryFields"))}>
              <Flex vertical gap={32}>
                <Input
                  name="email"
                  label={t("changePassword.inputs.email")}
                  rules={[
                    {
                      required: true,
                      type: "email",
                    },
                  ]}
                />
                <ErrorBoundary>
                  <PasswordButtons loading={loading} />
                </ErrorBoundary>
              </Flex>
            </Form>
          </Flex>
        </section>
      </MainPage>
    </ScreenSplit>
  );
};
